import { FC } from 'react';

import Jumbotron, { JumbotronProps } from 'modules/common/components/Jumbotron';

interface Props {
  alt: string;
  bgImg: string;
  bgImgObjectFit?: 'cover' | 'contain';
  fullHeight?: boolean;
  isJumbotronResponsive?: boolean;
  jobTypeId?: string;
  jumbotronProps?: Pick<JumbotronProps, 'fullHeight' | 'isResponsive' | 'bgImgObjectFit'>;
  shouldUseOverlayBackgroundColor?: boolean;
  shouldUseOverlayPadding?: boolean;
}

const Banner: FC<Props> = ({
  alt,
  bgImg,
  children,
  fullHeight = true,
  jobTypeId,
  shouldUseOverlayBackgroundColor = true,
  shouldUseOverlayPadding = true,
  jumbotronProps = {},
}) => (
  <Jumbotron
    bgImg={bgImg}
    alt={alt}
    bgPos="center"
    fullHeight={fullHeight}
    jobTypeId={jobTypeId}
    {...jumbotronProps}
  >
    <div className="overlay">
      <div className="content">{children}</div>
    </div>
    <style jsx>
      {`
        .overlay {
          height: 100%;
          width: auto;
          background-color: ${shouldUseOverlayBackgroundColor
            ? 'rgba(0, 0, 0, 0.3)'
            : 'transparent'};
          display: flex;
          justify-content: center;
          align-items: center;
          padding: ${shouldUseOverlayPadding ? '0 16px' : '0'};
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          overflow: hidden;
        }

        .content :global(input) {
          border-radius: 4px;
        }
      `}
    </style>
  </Jumbotron>
);

export type { Props as BannerProps };
export default Banner;
